export default (theme) => ({
  root: {
    color: theme.palette.type === "dark" ? "white" : "black",
    fontWeight: 300,
    fontFamily: "open-sans, sans-serif",
  },
});
